import {
    SurveysService
} from '@/common/api.service.js'

export class Survey {
    constructor ({
        id = null,
        survey_name = null,
        user = null,
        compilation_multiple = null,
        compilation_editable = null,
        visible = null,
        surveyjs_version = null,
        created_at = null,
        updated_at = null,
        waves = null
    } = {}) {
        this.id = id
        this.survey_name = survey_name
        this.user = user
        this.compilation_multiple = compilation_multiple
        this.compilation_editable = compilation_editable
        this.visible = visible
        this.surveyjs_version = surveyjs_version
        this.created_at = created_at
        this.updated_at = updated_at
        this.waves = waves
    }

    get activeWave () {
        let wave = this.waves.find((w) => {
            return w.state === 1
        })
        return wave || false
    }
}

export function responseAdapter (response) {
    return new Survey({
        ...response
    })
}

export function requestAdapter (request) {
    return request
}

export default {
    getSingle: id => new Promise((resolve, reject) => {
        SurveysService.get(id)
            .then(({
                data
            }) => {
                resolve({
                    data: responseAdapter(data),
                    id: id
                })
            }).catch(e => {
                reject(e)
            })
    }),
    getList: params => new Promise((resolve, reject) => {
        SurveysService.query(params)
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    })
}
